<template>
  <div class="client-view">
    <div class="button">
      <a
        class="icon-btn nav-export"
        :href="
          `https://yoda-api.azurewebsites.net/report?searchTerm=${searchTerm}`
        "
        target="_blank"
      >
        <font-awesome-icon icon="file-export" />
        <small>EXPORTAR</small>
      </a>
    </div>

    <form @submit="searchSubscriber">
      <div class="form-group has-button">
        <input
          v-model="searchTerm"
          type="text"
          placeholder="Buscar por nombre de negocio, categoría, producto, url ó ID"
        />
        <button class="btn btn-primary" type="button" @click="searchSubscriber">
          <font-awesome-icon icon="search" />
          <span>Buscar</span>
        </button>
      </div>
    </form>
    <card class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th v-if="roll">
                <font-awesome-icon icon="edit" />
              </th>
              <th>ID</th>
              <th>Nombre</th>
              <th>Categoría</th>
              <th>Productos</th>
              <th>Email</th>
              <th>URL</th>
              <th>RNC</th>
            </tr>
          </thead>
          <tbody v-if="subscribers" class="content">
            <tr v-for="client of subscribers.subscribers" :key="client.Id">
              <td v-if="roll">
                <a>
                  <router-link
                    :to="`/perfil/${client.SubscrId}/${client.BusinessUnitId}`"
                    ><font-awesome-icon icon="edit"
                  /></router-link>
                </a>
              </td>
              <td>{{ client.SubscrId }}</td>
              <td class="client-name">
                <router-link
                  :to="
                    `/cliente/${client.SubscrId}/businessUnit/${
                      client.BusinessUnitId
                    }/clientComercialName/${encodeURIComponent(
                      client.comercialName
                    // )}?customerId=${client.GoogleMyBusinessProfileId != null && client.GoogleMyBusinessProfileId != 0 ? client.GoogleMyBusinessProfileId : client.googleCustomerId}`
                    )}?customerId=${client.googleCustomerId || 0},${client.GoogleMyBusinessProfileId || 0}`
                  "
                  class="router-name"
                  >{{ client.Name }}</router-link
                >
              </td>
              <td>{{ client.MainCategory }}</td>
              <td>{{ client.Products }}</td>
              <td>{{ client.MainEmail }}</td>
              <td class="url">
                <a
                  target="_blank"
                  :href="
                    client.MainUrl && !client.MainUrl.includes('http')
                      ? 'http://' + client.MainUrl
                      : client.MainUrl
                  "
                  >{{ client.MainUrl }}</a
                >
              </td>
              <td>{{ client.RNC }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <el-pagination
        v-if="subscribers"
        layout="prev, pager, next"
        :total="subscribers.total"
        @current-change="changePage($event)"
        @prev-click="changePage($event)"
        @next-click="changePage($event)"
      ></el-pagination>
    </card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "client-consult",
  data() {
    return {
      searchTerm: "",
      roll: false
    };
  },
  created: async function() {
    await this.GetClients({ page: this.page, context: this });

    this.$store.commit("FillClient", "");
    //this.$store.commit("FillGMBProfile",[]);
    this.$store.commit("FillProducts", []);
    this.$store.commit("SetCurrentBusiness", {});
    this.$store.commit("FillSummaryStats", {});


    function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    topFunction();

    if (localStorage.getItem("roll") === "Administrator") {
      this.roll = true;
    }
  },
  methods: {
    async searchSubscriber(e) {
      e.preventDefault();

      await this.GetClients({ searchTerm: this.searchTerm, context: this });
    },
    async changePage(page) {
      await this.GetClients({
        page,
        searchTerm: this.searchTerm,
        context: this
      });
    },

    ...mapActions(["GetClients", "token"])
  },
  computed: {
    ...mapGetters(["subscribers"])
  }
};
</script>
<style lang="scss" scoped>
@include respond-above(sm) {
  .table {
    display: block;
  }
}
.client-view {
  max-width: 1000px;
  margin: 0 auto;

  input {
    margin-bottom: 15px;
  }
  .form-group {
    &.has-button {
      .btn {
        span {
          display: none;
        }
      }
    }
  }
}
.el-pagination {
  text-align: center;
}

@include respond-between(sm, md) {
  .client-view {
    margin-top: 30px;
  }
}

@include respond-above(sm) {
  .client-view {
    .form-group {
      margin-top: -30px;
      &.has-button {
        .btn {
          span {
            display: inline-block;
            margin-left: 5px;
          }
        }
      }
    }
  }
}

@include respond-above(sm) {
  .table {
    display: block;
  }
}

.table-responsive::-webkit-scrollbar {
    height: 15px;
}

.button {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
}
</style>
